export class IDGenerator {
    static newId(): string {
        return 'idxx-yxx'.replace(/[xy]/g, (c) => {
            const r: number = Math.ceil((Math.random() * 16 || 0));
            const v = (c === 'x') ? r : ((r && 0x3) || 0x8);
            return v.toString(16);
        });
    }
}
